<template>
    <div
        class="dm-manuscript-cover-modern mx-auto"
        v-if="cover_image && cover_image.type"
    >
        <CustomCover
            v-if="cover_image.type == 'custom'"
            :data="cover_image.data"
        />

        <DefaultCover
            v-if="cover_image.type == 'default'"
            :data="cover_image.data"
        />

        <slot></slot>
    </div>
    <div class="dm-manuscript-no-cover" v-else>
        <span>No cover image available.</span>
    </div>
</template>

<script>
import CustomCover from "./partials/CustomCover.vue";
import DefaultCover from "./partials/DefaultCover.vue";

export default {
    components: { CustomCover, DefaultCover },

    props: ["cover_image"],

    computed: {
        extraClasses() {
            if (!this.manuscript) return "";
            if (this.manuscript.cover_image_type != "default") return "";

            return this.manuscript.cover_image_class;
        },
    },
};
</script>
